export var blockDefaultEvent = function blockDefaultEvent(e) {
  e.preventDefault();
  e.stopPropagation();
};
export var closePopup = function closePopup() {
  return window.dispatchEvent(new CustomEvent("closePopup"));
};